
import { days, getAvailabilityFromNewBooking, setTimesFromBinaries } from "../../Utils/TimeSlotUtils";
import { NewBookingView } from "../../firestore/Types/NewBookingSchema";

export function TimeSlotsPretty({ title, newRequest }: { title: string, newRequest: NewBookingView | undefined }) {

	const render = () => {
		if (newRequest) {
			const binaries = getAvailabilityFromNewBooking(newRequest);
			const days = setTimesFromBinaries(binaries);
			return (
				<div >
					<div className="ml-4">
						{displayAllTimes(days)}
					</div>
				</div>
			)
		}
	
	}
	return (
		<div className="grow flex flex-col">
			<div className="basic-form-label">
				{title}
			</div>
			<div className="ml-4">
				{render()
				}
			</div>
		</div>
	);
}

function displayAllTimes(times: string[][]) {
	return (
		times.map((day, index) => {
			if (day.length > 0) { 
				return (
					<div key={index}>
						<div className="basic-form-value-text">
							{days[index]}:
						</div>
						<div className="ml-4">
							{displayTimes(day)}
						</div>
					</div>
				)
			}
			return (
				<div key={index}></div>
			)
		}));
}

function displayTimes(day: string[]) {
	return (
		day.map((times, index) => (
			<div className="flex flex-row" key={index}>
				<div className="border-l-4 border-b-4 border-indigo-500 h-3 w-3" />
				<div className="basic-form-value-text pl-2">
					{times}
				</div>
			</div>
		)));
}